module.exports = __webpack_public_path__ + "static/media/product-layout-three.70149f56.png";